import { useForm, Controller } from "react-hook-form";
import React, { useContext, useState } from "react";
import {
  TextButton,
  TextInput,
  ModalContext,
  ModalButtonsContainer,
  REQUIRED_ERROR_MESSAGE,
} from "@SeemplicityDev/shared";

interface ChangeUserPasswordFormValues {
  newPassword: string;
}

export interface ChangeUserPasswordProps {
  OnSubmit: (newPassword: string) => Promise<void>;
}

const ChangeUserPassword: React.FC<ChangeUserPasswordProps> = ({
  OnSubmit,
}) => {
  const methods = useForm<ChangeUserPasswordFormValues>({ mode: "all" });
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = methods;
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const { closeModal } = useContext(ModalContext);
  const onSubmit = (data: ChangeUserPasswordFormValues) => {
    setIsSubmittingForm(true);
    OnSubmit(data.newPassword).then(() => setIsSubmittingForm(false));
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name={"newPassword"}
          render={({ field: { value, onChange, onBlur } }) => {
            return (
              <TextInput
                type={"text"}
                value={value}
                data-testid={"new-password"}
                labelTop
                onBlur={onBlur}
                name={"newPassword"}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  onChange(e);
                }}
                label={"New Password"}
                required
                error={errors.newPassword ? errors.newPassword : null}
              />
            );
          }}
          control={control}
          rules={{
            required: REQUIRED_ERROR_MESSAGE,
          }}
        />
        <ModalButtonsContainer>
          <TextButton
            type="button"
            data-testid={"cancel-change-user-password"}
            label={"Cancel"}
            onClick={closeModal}
          />
          <TextButton
            type="submit"
            label={"Change Password"}
            data-testid={"change-password"}
            buttonsStyle={"secondary"}
            rightIcon={isSubmittingForm ? "seem-icon-spinner spinner" : ""}
            isSubmitting={isSubmittingForm}
            disabled={!isValid || !isDirty || isSubmittingForm}
          />
        </ModalButtonsContainer>
      </form>
    </div>
  );
};
export default ChangeUserPassword;
